import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'portals';
export const portalsServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const PortalsServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: portalsServiceEventType(),
}));
